import { fetchAgencies } from 'syft-acp-core/api/resources/agencies'
import { takeEveryApiCall } from './helpers'

export default function* root() {
  yield takeEveryApiCall('AGENCIES_FETCH', fetchAgencies)
}
